export default __webpack_public_path__ + "static/media/Artes-Visuales.e683cb88.png";